import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/feature/JsonLd';
import { buildOrganizationSchema, buildWebSiteSchema, buildFaqSchema } from '@/lib/schema';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import ResourcesSection from './components/ResourcesSection';
import PillarSection from './components/PillarSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  const { i18n, t } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  const schema = [
    buildOrganizationSchema(),
    buildWebSiteSchema(),
    buildFaqSchema([
      { question: t('faq.q1'), answer: t('faq.a1') },
      { question: t('faq.q2'), answer: t('faq.a2') },
      { question: t('faq.q3'), answer: t('faq.a3') },
      { question: t('faq.q4'), answer: t('faq.a4') },
    ]),
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={schema} />
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <ResourcesSection />
        <PillarSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}